namespace('compass.arctic');

compass.arctic.TimedOutWidget = compass.defineWidget(function TimedOutWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom;

	this.render = function(widgetElem) {
		var timedOutTitle = 'Time\'s Up!';
		var timedOutText = "Looks like your session has timed out. All good things must come to an end, right? Please click OK to reset the clock and start over.";

		var timedOutButton = d.button({
			className: 'secondaryButton',
			'aria-role' : 'button',
			role : 'button',
			tabindex : 0
		}, 'OK');

		timedOutButton.activate(function() {
			me.trigger(CompassEvents.TimedOut);
		});

	  var timedOutDiv = d.div({
			className: 'timedOutContents'
		}, d.div(d.h2(timedOutTitle), d.div(timedOutText, timedOutButton))
		);

		var _timedOutDialog = d.dialog({ //modal = true, disable clicking outside modal, disable click to close
			classes: 'TimedOutWidget',
			contents: timedOutDiv,
			centerOnView: true,
			disableClicksOutsideModal: true
		});
		widgetElem.append(_timedOutDialog);
	};

}, {
	GUID : 'defaultTimedOutWidgetGUID',
	widgetName : 'TimedOutWidget'
});
